export default "__VITE_ASSET__01edbc7f__"